// extracted by css-extract-rspack-plugin
export default {"cls1":"ClaimEvaluationRow-cls1_Pht","cls2":"ClaimEvaluationRow-cls2_ML_ ClaimEvaluationRow-cls1_Pht"};